import * as React from "react";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {RouteComponentProps} from "react-router";
import {deleteSessionStorage, getSessionStorage} from "../../../../../CommonFunctions";
import {Link} from "react-router-dom";

interface IProps extends RouteComponentProps<{}> {
    location: any;
}

interface IClaimSubmittedPageState {
    rentersClaim: any;
}

@authorize
export class ClaimSubmittedPage extends React.Component<IProps, IClaimSubmittedPageState> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
        const rentersClaim: any = getSessionStorage("rentersClaim");

        this.state = {
            rentersClaim: rentersClaim !== null ? rentersClaim : {},
        }
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Your renters claims");
        window.addEventListener("beforeunload", this.clearSession);
    }

    public componentWillUnmount() {
        window.removeEventListener("beforeunload", this.clearSession);
        this.clearSession();
    }

    public render() {
            return (
                <React.Fragment>
                    <FalconHeader/>

                    <div className="page-contents text-center">
                        <div className="section-panel pt-4">
                            <div className="text-right mb-5">Claim no: <b>{this.state.rentersClaim.claimReference}</b></div>
                            <div className="mb-4">
                                <img className="d-block m-auto" src="/img/Flow-green-tick-desktop.svg" alt="Tick icon" height={100}/>
                            </div>
                            <h1>We received your claim</h1>
                            <h1>What's next?</h1>
                            <div className="pb-1">We've sent an email confirming claims details to</div>
                            <div className="pb-1"><b className="long-word">{this.state.rentersClaim.email}</b></div>
                            <div className="pb-1">Our team will be looking over the claim and will get in touch with you in 48h</div>
                            <div className="pb-1">For any questions call our 24 hour helpline on</div>
                            <div>
                                <a href="tel:+44 0800 030 4898" className="a-bold">0800 030 4898</a> or{' '}
                                <a href="tel:+44 0120 2856 143" className="a-bold">(+44)0120 2856 143 </a>
                                <span><b>24/7</b></span>
                            </div>
                        </div>
                        <Link className="btn btn-primary btn-next btn-payment-success" to="/dashboard">Go to your account</Link>
                    </div>

                    <FalconFooter/>
                </React.Fragment>
            );
    }

    private clearSession = (): void => {
        deleteSessionStorage("onlineRentersClaimRequest");
        deleteSessionStorage("valuableItems");
        deleteSessionStorage("rentersClaim");
        deleteSessionStorage("whenAndWhere");
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/rentersClaims/ClaimSubmittedPage.tsx